import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext } from "@-/com.npmjs.use-context-selectors";
import type { CollectionsLayoutContextValue } from "#use-collections-layout-context-value";

export const CollectionsLayoutContext = createContext(
  defaultError<CollectionsLayoutContextValue>("CollectionsLayoutContext"),
);
